import React from 'react';
import LeftBox from './LeftBox';

function LeftSection({
  context,
  protocolData,
  institutionalData,
  setProtocolData,
  setInstitutionalData,
  getAutocompleteCtepIdApiAction,
  getProtocolAuoCompleteApiAction,
  isInstitutionDisabled = false,
  isProtocolDisabled = false,
  signatoryCtepId = null
}) {
  let title = 'Institutional CTEP ID';
  if (signatoryCtepId != null) {
    title = `${title} (affiliated to ${signatoryCtepId})`;
  }
  return (
    <div className="col-5 mr-4">
      <LeftBox
        isDisabled={isInstitutionDisabled}
        context={context}
        title={title}
        button="Clear Institutions"
        data={institutionalData}
        isInstitution
        setData={setInstitutionalData}
        getAutoCompleteAction={getAutocompleteCtepIdApiAction}
        signatoryCtepId={signatoryCtepId}
      />
      <LeftBox
        isDisabled={isProtocolDisabled}
        context={context}
        title="Protocol Number"
        button="Clear Protocols"
        data={protocolData}
        setData={setProtocolData}
        getAutoCompleteAction={getProtocolAuoCompleteApiAction}
      />
    </div>
  );
}

export default LeftSection;
